import React, { useEffect, useRef, useState } from "react";
import ApiEngine from "../../util/ApiEngine.js";
import { ApiKey, ApiUrl, LanguageKey, WebUrl } from "../../util/Constant.js";
import { showResponseMessage } from "../../redux/AppAction.js";
import { createFormBody } from "../../util/Util.js";
import { performLogout } from "../../redux/AuthAction.js";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Keyboard from "react-simple-keyboard";
import PinInput from "react-pin-input";
import { Alert } from "reactstrap";
import NavigationButton from "../../components/custom/NavigationButton";

const GamePage = (props) => {
  const _dispatch = useDispatch();
  const _history = useHistory();
  const _location = useLocation();
  const { t } = useTranslation(LanguageKey._PRIMARY);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const gameId = params.get("gameId");
  const [sourceLink, setSourceLink] = useState("");
  const [unclaimComm, setUnclaimComm] = useState("");
  const [memberData, setMemberData] = useState([]);
  const [initCheck, setInitCheck] = useState(false);
  const [loadingMemberFlag, setLoadingMemberFlag] = useState(false);
  const [walletDetails, setWalletDetails] = useState(false);
  const [showRightMenu, setShowRightMenu] = useState(false);
  const [showPinEntry, setShowPinEntry] = useState(false);
  const [theInterval, setTheInterval] = useState(false);
  const [invalidPin, setInvalidPin] = useState(false);
  const [pinNumber, setPinNumber] = useState("");
  const [enteredPinNumber, setEnteredPinNumber] = useState("");
  const [pinNumberFocused, setPinNumberFocused] = useState(0);
  const [pinNumberConfirm, setPinNumberConfirm] = useState("");
  const [enteredPinNumberConfirm, setEnteredPinNumberConfirm] = useState("");
  const [pinNumberConfirmFocused, setPinNumberConfirmFocused] = useState(0);
  const [pinNumberFinal, setPinNumberFinal] = useState("");
  const [enteredPinNumberFinal, setEnteredPinNumberFinal] = useState("");
  const [pinNumberFinalFocused, setPinNumberFinalFocused] = useState(0);
  const [forgetPin, setForgetPin] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [smsSent, setSmsSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [currentWindowHeight, setCurrentWindowHeight] = useState(
    Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    )
  );
  const [currentWindowWidth, setCurrentWindowWidth] = useState(
    Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
  );
  //var pageToGoBack = "";
  const _COUNTDOWN_PERIOD = 120;
  const _SECONDS_IN_MS = 1000;
  const _ALERT_TIMEOUT = 3000;
  const [countdownPeriod, setCountdownPeriod] = useState(0);

  const elePin = useRef(null);
  const eleConfirm = useRef(null);
  const eleFinalPin = useRef(null);
  const keyboard = useRef();

  var style = {};
  const enterGameUrl = _location.state.enterGameUrl;
  const isDemo = _location.state.isDemo;
  const gameName = _location.state.gameName;
  const pageToGoBack = _location.state.pageToGoBack;

  useEffect(() => {
    document.body.style.overflowY = 'hidden';
    init();
    window.onresize = _adjust_iframe_size;
    setInitCheck(true);
  }, []);

  async function init() {
    try {
      const responseJson = await ApiEngine.get(
        enterGameUrl
      );
      const data = responseJson;
      const start = data.indexOf("'");
      const end = data.indexOf("'", start + 1);
      const result = data.substring(start + 1, end);
      setSourceLink(result);
    } catch (errorMessage) {
      _dispatch(showResponseMessage(false, errorMessage));
    }
  }

  function _adjust_iframe_size() {
    let tempH = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );
    setCurrentWindowHeight(tempH);
    let tempW = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    setCurrentWindowWidth(tempW);
  }

  const CloseGame = () => {
    document.body.style.overflowY = 'auto';
    _history.push({
      pathname: pageToGoBack,
    });
  }

  return (
    <div id="game-page">
      <div className="iframe-container"
        style={{
          border: "none",
          height: currentWindowWidth > currentWindowHeight
            ? "100vh"
            : "calc(100vh - 120px)",
          width: currentWindowWidth > currentWindowHeight ? "100vw" : "100%",
          position: currentWindowWidth > currentWindowHeight ? "fixed" : "unset",
          top: "0",
          left: "0",
        }}>
        <div className="iframe-header">
          <div style={{ display: 'flex', gridColumnGap: '20px', alignItems: 'center' }}>
            <div className="game-page-pulse-wrapper">
              <div className="game-page-pulse-title">
                <b></b>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <span className="iframe-title">{gameName}</span>
              <span className="iframe-title">{isDemo ? t("ON_FUN_PLAY") : t("ON_REAL_PLAY")}</span>
            </div>
          </div>
          <div className="iframe-controls">
            <img
              src="/img/version3/gamePage-Close.svg"
              className="img-responsive"
              alt="close"
              onClick={CloseGame}
            />
          </div>
        </div>
        {initCheck && (
          <iframe
            className="iframe-content"
            src={sourceLink}
          />
        )}
      </div>
    </div>
  );
};
export default GamePage;
